import React from "react";
import {AbstractLiveblogElement} from "./AbstractLiveblogElement";
import {PropsParser} from "@webng/validations";
import {SharedThemeConfiguration, sharedThemeConfigurationPropsParser} from "@webng-types/embedjs";
import {LiveblogPortalWidget} from "./liveblog-portal/LiveblogPortalWidget";
import {
  LiveblogPortalWidgetApi,
  LiveblogPortalWidgetProps,
  LiveblogPortalWidgetQueryProps,
  liveblogPortalWidgetQueryPropsParser,
  LiveblogPortalWidgetTagProps,
  liveblogPortalWidgetTagPropsParser
} from "./liveblog-portal/LiveblogPortalWidgetProps";

const propsParser: PropsParser<LiveblogPortalWidgetTagProps> = {
  ...liveblogPortalWidgetTagPropsParser,
};

export class TickarooLiveblogPortalElement extends AbstractLiveblogElement<{}, LiveblogPortalWidgetTagProps, LiveblogPortalWidgetQueryProps, LiveblogPortalWidgetApi> {
  static get observedAttributes() {
    return [
      ...Object.keys(propsParser).map((x) => x.toLowerCase()),
      ...Object.keys(sharedThemeConfigurationPropsParser).map((x) =>
        x.toLowerCase()
      ),
    ];
  }

  constructor() {
    super({...sharedThemeConfigurationPropsParser}, liveblogPortalWidgetTagPropsParser, liveblogPortalWidgetQueryPropsParser);
  }

  useHydrate(props: {
    tagProps: LiveblogPortalWidgetTagProps;
    queryProps: LiveblogPortalWidgetQueryProps;
    overrideConfigurationProps: Partial<SharedThemeConfiguration>
  }): boolean {
    return false;
  }

  renderImp(ref: (r: LiveblogPortalWidgetApi) => void, props: {
    tagProps: LiveblogPortalWidgetProps;
    queryProps: LiveblogPortalWidgetQueryProps;
    overrideConfigurationProps: Partial<SharedThemeConfiguration>
  }): React.ReactNode {
    const finalProps = Object.assign({}, props.tagProps, props.queryProps, {overrideConfiguration: props.overrideConfigurationProps});
    return <LiveblogPortalWidget ref={ref} {...finalProps} />;
  }
}
